module.exports = __webpack_public_path__ + "fonts/VetoSans-MediumItalic_1.58effb6b.woff2";